import duckify from "../../tools/duckify";

export const namespace = "cassie";
export const store = "common";

export const Types = duckify(namespace, store, ["EVALUATE", "DONE"]);

/**
 * @constant NOTICE
 * @description Action type for the loading notice. A plain string rather than a duckified type
 * because the reducer has always matched `EVALUATE`/`DONE` as plain strings - that is what the
 * sagas put - and a namespaced type would simply never arrive.
 * @memberof module:Common
 */
export const NOTICE = "LOADING_NOTICE";

export const Actions = {
  evaluate: () => ({
    type: Types.EVALUATE,
  }),
  done: () => ({
    type: Types.DONE,
  }),
  /**
   * @function notice
   * @description Says what is being loaded, for the one loading indicator the app shows. Showing it
   * is part of the same action: anything worth a wait is worth naming, and a notice with no text
   * would be the "Carregando..." with no subject that this replaces.
   * @param {String} title - What is happening, in a few words.
   * @param {String} [detail] - The part that keeps changing - which image, how many are left.
   * @memberof module:Common
   * @returns {Object} The action.
   */
  notice: (title, detail = "") => ({
    type: NOTICE,
    payload: { title, detail },
  }),
  /**
   * @function clearNotice
   * @description Takes the loading indicator down.
   * @memberof module:Common
   * @returns {Object} The action.
   */
  clearNotice: () => ({
    type: NOTICE,
    payload: { title: "", detail: "" },
  }),
};

export default Actions;
